import { Divider } from 'antd';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './LeftOutsideDesignMenu.scss';
import { useContext, useEffect } from 'react';
import { DesignerPageContext } from '../../DesignerPage';
import { ModuleType } from '../../../../constants/enum';
import { useSelector } from 'react-redux';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';

const LeftOutsideDesignMenu = ({
  open,
  onDragStart,
  title,
  moduleType,
  onClose,
}) => {
  return (
    <LeftMenuDesign
      open={open}
      classNames={{ root: '!left-[60px] relative', content: '!p-0 gap-0' }}
      header={
        <>
          <span className="text-title-large text-nowrap">{title}</span>
          <ButtonIconGhostSmall icon={<Icon.ICClose />} onClick={onClose} />
        </>
      }
      content={open ? <RenderContent moduleType={moduleType} /> : null}
    />
  );
};

export default LeftOutsideDesignMenu;

const RenderContent = ({ moduleType }) => {
  const { t } = useTranslation();
  const { sceneManager, setCurrentMaterial, currentMaterial } =
    useContext(DesignerPageContext);
  const { textureType } = useSelector(state => state.module);

  useEffect(() => {
    if (sceneManager) {
      let material = {};
      if (moduleType === ModuleType.BACKSPLASH) {
        material = {
          ...material,
          [moduleType]: sceneManager.backsplash,
        };
      } else if (moduleType === ModuleType.COUNTERTOP) {
        material = {
          ...material,
          [moduleType]: sceneManager.countertop,
        };
      }
      setCurrentMaterial({ ...material });
    }
  }, [open, moduleType, sceneManager]);

  return (
    <>
      <Divider
        type="horizontal"
        style={{ margin: 0, backgroundColor: '#F4F4F4' }}
      />
      <div className="grid grid-cols-2 p-8 items-start align-content-start gap-2 self-stretch">
        {moduleType === ModuleType.COUNTERTOP ? (
          <CardProduct
            md={{}}
            title={t('No countertop')}
            moduleType={moduleType}
            onClick={async () => {
              await sceneManager.removeAllCountertop();
              if (currentMaterial?.[moduleType]) {
                setCurrentMaterial();
              }

              await sceneManager.calculateTotalCost?.({});
            }}
          />
        ) : moduleType === ModuleType.BACKSPLASH ? (
          <CardProduct
            md={{}}
            title={t('No backsplash')}
            moduleType={moduleType}
            onClick={async () => {
              await sceneManager.removeAllBacksplash();
              if (currentMaterial?.[moduleType]) {
                setCurrentMaterial();
              }

              await sceneManager.calculateTotalCost?.({});
            }}
          />
        ) : (
          <CardProduct
            md={{}}
            title={t('No lighting')}
            moduleType={moduleType}
            onClick={async () => {
              await sceneManager.removeAllLedDecor();
              if (currentMaterial?.[moduleType]) {
                setCurrentMaterial();
              }

              setTimeout(async () => {
                await sceneManager.calculateTotalCost?.({});
              }, 200);
            }}
          />
        )}

        {textureType.data?.map((md, i) => {
          const name = getValueFromString(md.name);
          return (
            <CardProduct
              key={i}
              md={md}
              title={name}
              moduleType={moduleType}
              active={currentMaterial?.[moduleType]?.material?.type === md.type}
              onClick={async () => {
                if (moduleType === ModuleType.COUNTERTOP) {
                  sceneManager.addAllCountertop(md);
                } else if (moduleType === ModuleType.BACKSPLASH) {
                  sceneManager.addAllBacksplash(md);
                } else if (moduleType === ModuleType.LED_DECOR) {
                  sceneManager.addAllLedDecor(md);
                }

                if (!currentMaterial || currentMaterial[moduleType]) {
                  setCurrentMaterial({
                    [moduleType]: {
                      material: md,
                    },
                  });
                }

                // designerPageContext.setMaterialType(md.type);
                setTimeout(async () => {
                  await sceneManager.calculateTotalCost?.({});
                }, 200);
                return;
              }}
            />
          );
        })}
      </div>
    </>
  );
};
